import { CacheOptions, IApp, IApplicationAssetRegister } from '@kurtosys/types/appsInitialize/index.js';
import { IManifest } from '@kurtosys/types/appsManager/index.js';


export function getElementsForAppInstance(app: IApp): HTMLElement[] {
	const { templateId: appTemplateId, version: appVersion } = app;
	return getElementsForApp({ appTemplateId, appVersion });
}

export function getElementsForManifest(manifest: IManifest): HTMLElement[] {
	const { ksysAppTemplateId: appTemplateId, version } = manifest;
	const appVersion = version.startsWith('v') ? version : `v${version}`;
	return getElementsForApp({ appTemplateId, appVersion });
}

export function getElementsForApp(target: { appTemplateId: string; appVersion?: string }): HTMLElement[] {
	const { appTemplateId, appVersion = 'v1.0.0' } = target;
	const ksysAppTemplateIdDataKey = 'data-ksys-app-template-id';
	const ksysAppTemplateVersionDataKey = 'data-ksys-app-template-version';
	const elements = document.querySelectorAll(`[${ksysAppTemplateIdDataKey}="${appTemplateId}"]`);
	const elementsWithCombinedVersion = document.querySelectorAll(
		`[${ksysAppTemplateIdDataKey}="${appTemplateId}-${appVersion}"]`,
	);
	let elementsCollection: HTMLElement[] = [];
	if (elements) {
		elementsCollection = Array.from(elements) as HTMLElement[];
		const versions = Object.keys(
			elementsCollection.reduce(
				(acc: { [key: string]: boolean }, element): { [key: string]: boolean } => {
					const version = element.getAttribute(ksysAppTemplateVersionDataKey);
					if (version) {
						acc[version] = true;
					}
					return acc;
				},
				{ [appVersion]: true },
			),
		);
		if (versions && versions.length > 0) {
			const highestVersion = versions.sort().reverse()[0];
			elementsCollection = elementsCollection.filter((element): boolean => {
				const version = element.getAttribute(ksysAppTemplateVersionDataKey);
				return (!version && appVersion === highestVersion) || version === appVersion;
			});
		}
	}
	if (elementsWithCombinedVersion) {
		elementsCollection.push(...(Array.from(elementsWithCombinedVersion) as HTMLElement[]));
	}
	return elementsCollection;
}

export function appendCacheQueryString(
	fileName: string,
	assetRegister?: IApplicationAssetRegister,
	cacheOptions?: CacheOptions,
): string {
	const queryStringObj: { lastModified?: string; cache?: string } = {};
	if (assetRegister) {
		queryStringObj.lastModified = assetRegister.lastModified;
	}
	if (cacheOptions) {
		queryStringObj.cache = JSON.stringify(cacheOptions);
	}
	const queryString = Object.keys(queryStringObj).reduce((acc, key, index): string => {
		const value = queryStringObj[key];
		acc = `${acc}${index > 0 ? '&' : ''}${key}=${encodeURIComponent(value)}`;
		return acc;
	}, '');
	if (queryString && queryString.length > 0) {
		const separator = fileName.includes('?') ? '&' : '?';
		fileName = `${fileName}${separator}${queryString}`;
	}
	return fileName;
}
